import { useState } from "react"
import { Button, Stack, Typography } from "@mui/material"
import { PostBotPageLayout } from "../components/common/postBotPageLayout"
import type { GridRowSelectionModel } from "@mui/x-data-grid-pro"
import { Link } from "react-router-dom"
import type { TemplateWriteAccess } from "../hooks/useVersionDraft"
import { publicationsPath } from "../hooks/publicationSessionDraft"
import { PostBotNavigation } from "../components/common/postBotNavigation"
import { PublicationsTable } from "../components/publications/publicationsTable"
import { BulkVersionDialog } from "../components/publications/bulkVersionDialog"

/** Task17 owns route registration and access policy. */
export default function PublicationsPage({
  canWrite,
  readOnly,
}: TemplateWriteAccess) {
  const [selection, setSelection] = useState<GridRowSelectionModel>([])
  const [bulkStarted, setBulkStarted] = useState(false)
  const [bulkOpen, setBulkOpen] = useState(false)
  const writable = !readOnly && canWrite !== false
  return (
    <PostBotPageLayout>
      <PostBotNavigation />
      <Typography variant="h5">Публикации</Typography>
      {writable && (
        <Stack direction="row" useFlexGap flexWrap="wrap" spacing={1}>
          <Button
            component={Link}
            to={`${publicationsPath}/new`}
            variant="contained"
          >
            Создать публикацию
          </Button>
          <Button
            disabled={!bulkStarted && !selection.length}
            onClick={() => {
              setBulkStarted(true)
              setBulkOpen(true)
            }}
          >
            {bulkStarted
              ? "Продолжить смену версий"
              : "Сменить версии выбранных"}
          </Button>
        </Stack>
      )}
      <PublicationsTable
        selection={selection}
        onSelectionChange={writable ? setSelection : undefined}
      />
      {bulkStarted && (
        <BulkVersionDialog
          open={bulkOpen}
          selectedIds={selection.map(String)}
          readOnly={readOnly}
          canWrite={canWrite}
          onClose={() => setBulkOpen(false)}
        />
      )}
    </PostBotPageLayout>
  )
}
